import React, { memo } from "react"
import FormControl from "@material-ui/core/FormControl"
import MenuItem from "@material-ui/core/MenuItem"
import MuiSelect from "@material-ui/core/Select"
import MenuDown from "components/Icons/MenuDown.icon"
import { FormElement } from "components/FormElement"
import { Typography } from "@material-ui/core"
import { Option, ISelectProps } from "./types"
import { usePaperStyles } from "./style"

function Select({
  required,
  label,
  name,
  disabled,
  options,
  onChange,
  displayEmpty = true,
  extraHelperText,
  MenuProps,
  value: defaultValue,
  spacing,
  ...rest
}: ISelectProps) {
  const menuClasses = usePaperStyles()

  return (
    <FormElement
      required={required}
      name={name}
      label={label}
      disabled={disabled}
      onChange={onChange}
      extraHelperText={extraHelperText}
      spacing={spacing}
      inputRender={props => (
        <FormControl variant="outlined" fullWidth={true}>
          <MuiSelect
            {...rest}
            {...props}
            name={name}
            defaultValue={defaultValue}
            disabled={disabled}
            displayEmpty={displayEmpty}
            IconComponent={MenuDown}
            MenuProps={{
              classes: menuClasses,
              anchorOrigin: {
                vertical: "bottom",
                horizontal: "left",
              },
              transformOrigin: {
                vertical: "top",
                horizontal: "left",
              },
              getContentAnchorEl: null,
              ...MenuProps,
            }}
          >
            {options.map((option: Option, index: number) => (
              <MenuItem key={`${index}-${option.label}`} value={option.value}>
                <Typography variant="inherit" noWrap={true}>
                  {option.label}
                </Typography>
              </MenuItem>
            ))}
          </MuiSelect>
        </FormControl>
      )}
    />
  )
}

export default memo(Select)
